module.exports = __webpack_public_path__ + "img/scc-01.d56b2b93.png";